import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import useLabel from '../../../../../Vcard/components/Carousel/hooks/useLabel';
//------------------------------------------------------------------------------------------------
import BookmarkProgressBar from './../../../../../../components/BookmarkProgressBar';
import FadeInImage from './../../../../../../components/FadeInImage';
import { getContentInfoLive } from '../../../../utils/getDataFromLiveVodContent';
import { isChannelBlocked } from 'containers/EPG/utils';
import './style.scss';
import useRenderChapas from 'hooks/useRenderChapas';

//Este componente se encarga de renderizar el poster y la chapita de la card del resultado de una busqueda
export const PosterCard = ({ contentInfo }) => {
  const { renderLabel } = useRenderChapas();
  const generalInfo = getContentInfoLive(contentInfo);
  const asset = useSelector(state => state.asset);
  const blockedChannels = useSelector(
    state =>
      state.cvEpg.channelBlocker.statusControlPin?.data?.pin_channel?.info,
  );

  const booleanChannelBlock = isChannelBlocked(generalInfo.id, blockedChannels);
  return (
    <div className="poster-card">
      {contentInfo?.content_type === 'E' || contentInfo?.type === 'E'
        ? renderLabel(contentInfo?.channel_group?.common)
        : renderLabel(contentInfo)}
      {/* <--- Chapitas */}
      <FadeInImage
        classNames={['poster-card__image']}
        imageSrc={generalInfo.imgSrc}
        imageAlt="clarovideo poster"
        width="256"
        height="144"
      />
      {booleanChannelBlock && (
        <div className="overlay_lock_channel">
          <img src={asset?.playingLive_fullEpg_lockChannel_icon} />
        </div>
      )}
      {contentInfo?.bookmark && contentInfo?.bookmark?.last?.progress >= 0 && (
        <BookmarkProgressBar
          isLive={contentInfo.content_type === 'L'}
          bookmarkProgress={contentInfo?.bookmark?.last?.progress}
        />
      )}
    </div>
  );
};

PosterCard.propTypes = {
  contentInfo: PropTypes.object.isRequired,
};
